module.exports = {"tab_title":"Kumo Capital","meta_description":"Early Stage Investment Fund","meta_keywords":["Kumo Capital","Kumocapital","KUMO"]}